<template>
  <div class="cs-notify-data">
    <img src="@/static/default.svg" alt="">
    <p class="mb-0 cs-notify-data__description"> {{ content }} </p>
  </div>
</template>

<script>
import {Card, Loading} from "vant";

export default {
  props: {
    content: {
      type: String,
      required: true
    },
  },
  data() {
    return {
    };
  },

}
</script>

<style lang="css">
.cs-notify-data {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 156px);
}

.cs-notify-data p {
  color: #7A7A7A;
  text-align: center;
  font-family: SF Pro Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

</style>
